import styles from './ButtonGroup.module.scss'
import cx from 'classnames'
import { Container } from 'react-grid-system'
import { Button } from '~elements'
import { ButtonGroupProps } from '~types'
import { getGtmLinkPosition } from '~analyticsUtils'

const ButtonGroup = ({ buttons, btnGroupTitle, bottomDivider = true }: ButtonGroupProps) => {
  const ButtonGroupRender = () => {
    return buttons.map((button, index: number) => {
      const { id, ctaBtnText } = button
      return (
        <div className={styles['button-group__button']} key={id}>
          <Button
            color='light'
            fill='hollow'
            size='md'
            title={ctaBtnText}
            analytics={{
              linkPosition: getGtmLinkPosition(buttons, index),
              linkModule: 'button_group'
            }}
          />
        </div>
      )
    })
  }

  return (
    <div className={cx([styles['btn-group-container'], styles[bottomDivider ? '' : 'no-bottom-divider']])}>
      {buttons.length > 0 && (
        <Container className={'container'}>
          <p>{btnGroupTitle}</p>
          <div className={styles['button-group']}>{ButtonGroupRender()}</div>
        </Container>
      )}
    </div>
  )
}

export default ButtonGroup
